import { makeStyles } from '@material-ui/core/styles';
// Import { DIMENSIONS } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	searchContainer: {
		marginTop: 4, // 4 is necessary to align search height with filter buttons
		marginBottom: -theme.spacing(1),
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2),
			marginBottom: 0
		}
	},
	filterbarContainer: {
		// MinHeight: DIMENSIONS.SEARCH_HEIGHT + theme.spacing(3),
		// paddingTop: theme.spacing(1),
		// paddingBottom: theme.spacing(2),
	},
	filterbarItem: {
		paddingBottom: theme.spacing(2)
	},
	title: {
		paddingLeft: theme.spacing(0.5)
	},
	optionalColumnsSelect: {
		marginBottom: -theme.spacing(2),
		marginLeft: theme.spacing(2)
	}
}));
